import React, { useEffect } from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ThemeToggle from "./components/ThemeToggle";
import Home from "./pages/Home";
import { Helmet } from "react-helmet";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GameFullScreen from "./pages/GameFullScreen";
import Footer from "./components/Footer";
import { SeoHead } from "./components/SeoHead";


// Google Adsense script integration with async loading - replace with your actual client id
const ADSENSE_CLIENT_ID = "ca-pub-6545634854364065";

function loadAdsenseScript() {
  if (document.querySelector(`script[src*="adsbygoogle.js"]`)) return; // Avoid re-adding
  const script = document.createElement("script");
  script.setAttribute("data-ad-client", ADSENSE_CLIENT_ID);
  script.async = true;
  script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
}

export default function App() {
  useEffect(() => {
    loadAdsenseScript();
  }, []);

  return (
    <ThemeProvider>
      <SeoHead/>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ pt: 2, pb: 20 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <ThemeToggle />
        </Box>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game/:gameId" element={<GameFullScreen />} />
          </Routes>
        </BrowserRouter>
      </Container>
      <Footer />
    </ThemeProvider>
  );
}
